import { create } from 'zustand';

/**
 * Transient pointer-interaction state, kept out of the undoable canvas store.
 * Drives the hover highlight: which frame the cursor is over, suppressed while
 * the user is panning or zooming so the highlight doesn't chase the pointer
 * across frames during a camera move.
 */
interface InteractionState {
  hoveredId: string | null;
  panZoomActive: boolean;
  setHovered: (id: string | null) => void;
  setPanZoom: (active: boolean) => void;
}

export const useInteraction = create<InteractionState>((set) => ({
  hoveredId: null,
  panZoomActive: false,
  setHovered: (id) => set((s) => (s.hoveredId === id ? s : { hoveredId: id })),
  setPanZoom: (active) =>
    set((s) =>
      s.panZoomActive === active
        ? s
        : { panZoomActive: active, hoveredId: active ? null : s.hoveredId },
    ),
}));
